var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"top-screen show",on:{"click":_vm.scrollTop}},[_c('b-img',{attrs:{"alt":"","src":_vm.topscreenLogo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }